import { useEffect, useState, type CSSProperties } from 'react'
import { INTRO_SLIDES } from './introSlides'
import { useTabSwipe } from '../../hooks/useTabSwipe'
import { Claim, Frame } from './Frame'

// What Matlist is, before anything is asked: a few slides, each a recording of
// the real app (the landing's clips, components/DeviceFrames), swiped through
// or stepped with Next and the arrow keys. Skip and the last slide's button
// both go on to setting up the list.

export function IntroPager({ onDone }: { onDone: () => void }) {
  const [index, setIndex] = useState(0)
  const count = INTRO_SLIDES.length
  const last = index === count - 1
  const swipe = useTabSwipe(index, count, setIndex)
  const slide = INTRO_SLIDES[index]

  useEffect(() => {
    const key = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') setIndex(i => Math.min(i + 1, count - 1))
      if (e.key === 'ArrowLeft') setIndex(i => Math.max(i - 1, 0))
    }
    window.addEventListener('keydown', key)
    return () => window.removeEventListener('keydown', key)
  }, [count])

  return (
    <Frame steps={count} at={index} onSkip={onDone}
      stage={{
        ...swipe.bind,
        className: `ml-fr__pager${swipe.phase !== 'idle' ? ` is-moving is-${swipe.phase}` : ''}`,
        style: { '--ml-page-x': `${swipe.dx}px` } as CSSProperties,
      }}
      footer={last
        ? <button type="button" className="ml-btn ml-btn--primary ml-btn--wide" onClick={onDone}>Set up my list</button>
        : <button type="button" className="ml-btn ml-btn--primary ml-btn--wide" onClick={() => setIndex(index + 1)}>Next</button>}>
      <section key={index} className="ml-fr__slide" aria-roledescription="slide" aria-label={`${index + 1} of ${count}`}>
        {slide.devices()}
        <div className="ml-fr__words">
          <Claim lines={slide.title} />
          <p className="ml-fr__body">{slide.body}</p>
        </div>
      </section>
    </Frame>
  )
}
